import Axpi from '../axpi'

const urlPrefix = 'dynamics/sorority-wars/boosts'

const boostsAPI = {
  getInventory () {
    return Axpi.$http().get(urlPrefix)
  },
  getGifts () {
    return Axpi.$http().get(`${urlPrefix}/gifts`)
  },
  use (boostId) {
    return Axpi.$http().post(`${urlPrefix}/${boostId}/use`)
  },
  sendGift (boostId, sentPlayerId) {
    return Axpi.$http().post(`${urlPrefix}/${boostId}/gifts`, {
      sent_player_id: sentPlayerId
    })
  },
  acceptGift (giftId) {
    return Axpi.$http().post(`${urlPrefix}/gifts/${giftId}/accept`)
  }
}

export default boostsAPI
